/* Base paths */
export const RENTAL_MANAGER_PATH = 'rental-manager/leasing';
export const RENTER_HUB_PATH = 'renter-hub/leasing';
export const LOGIN_PATH = '/user/acct/login/';
export const PAYMENTS_PATH = '/rental-manager/payments/properties';
export const APPLICATIONS_PATH = '/rental-manager/applications';
export const PROPERTY_CONDITION_REPORT_PATH = '/rental-manager/property-condition/property';
export const RENTAL_PROTECTION_PATH = '/rental-manager/rental-protection/properties';
/* End Base paths */

/* Begin Tenant Routes */
const OLD_V1_ROOT = `${RENTER_HUB_PATH}/tenant`;
const TENANT_BASE = `/${RENTER_HUB_PATH}`;
export const RENTER_HUB_ROOT = TENANT_BASE;
const TENANT_LEASE_VIEW_ROOT = `${TENANT_BASE}/lease`;
export const TENANT = {
  OLD_LEASE_VIEW: `/${OLD_V1_ROOT}/lease-view/`,
  OLD_LEASE_VIEW_CAMELCASE: `/${OLD_V1_ROOT}/leaseView/`,
  OLD_WELCOME: `/${OLD_V1_ROOT}/lease-ready`,
  OLD_WELCOME_CAMELCASE: `/${OLD_V1_ROOT}/leaseReady`,
  WELCOME: `/${OLD_V1_ROOT}/welcome`,
  LEASE_DASHBOARD: `${RENTER_HUB_ROOT}`,
  LEASE_VIEW_ROOT: TENANT_LEASE_VIEW_ROOT,
  IDENTITY_CONFIRMATION: `${TENANT_BASE}/identity-confirmation`,
  OLD_IDENTITY_CONFIRMATION: `${RENTER_HUB_ROOT}/identityConfirmation`,
  LEASE_VIEW: `${TENANT_LEASE_VIEW_ROOT}/:leaseId/:nestedViewType?`,
  LEASE_EXTENSION_PREVIEW: `${TENANT_LEASE_VIEW_ROOT}/:leaseId/renewal/:renewalId/preview`,
  LEASE_EXTENSION_VIEW: `${TENANT_LEASE_VIEW_ROOT}/:leaseId/renewal/:renewalId`,
  TENANT_DRIVEN_LEASE_EXTENSION: `${TENANT_LEASE_VIEW_ROOT}/:leaseId/renew`,
};
/* End Tenant Routes */

/* Begin: Colandlord Routes */
export const COLANDLORD_ROOT = '/colandlord';
export const COLANDLORD = {
  LEASE_EXTENSION_WELCOME: `${COLANDLORD_ROOT}/lease/:leaseId/renewal/:renewalId/welcome`,
  LEASE_EXTENSION_SUMMARY: `${COLANDLORD_ROOT}/lease/:leaseId/renewal/:renewalId`,
  LEASE_EXTENSION_PREVIEW: `${COLANDLORD_ROOT}/lease/:leaseId/renewal/:renewalId/preview`,
  WELCOME: `${COLANDLORD_ROOT}/welcome`,
  LEASE_VIEW: `${COLANDLORD_ROOT}/lease/:leaseId/:nestedViewType?`,
};
/* End: Colandlord Routes */

/* Begin: Landlord Routes */
const LANDLORD_ROOT = '/property/:propertyId';
export const LEASE_UPLOAD = 'leaseUpload';
export const LANDLORD = {
  LANDLORD_ROOT,
  RENEWAL: `${LANDLORD_ROOT}/lease/:leaseId/renewal/:renewalId`,
  MANAGE_YOUR_LEASE: `${LANDLORD_ROOT}/lease/:leaseId/manage`,
  RENEWAL_PREVIEW: `${LANDLORD_ROOT}/lease/:leaseId/renewal/:renewalId/preview`,
  LEASE_REVIEW: `${LANDLORD_ROOT}/lease/:leaseId/review`,
  LEASE_GENERATE: `${LANDLORD_ROOT}/generate`,
  LEASE_VIEW: `${LANDLORD_ROOT}/lease/:leaseId/:viewType?/:nestedViewType?`,
  LEASE_SELF_SERVE: `${LANDLORD_ROOT}/lease/:leaseId/self-serve`,
  CREATE_LEASE: `${LANDLORD_ROOT}/create`,
  // Old routes (deprecated, for redirects only)
  OLD_CREATE_LEASE: `${LANDLORD_ROOT}/onboarding/createLease`,
  OLD_SELF_SERVE: `${LANDLORD_ROOT}/lease/:leaseId/selfServe`,
};
/* End: Landlord Routes */

/* Begin: Misc Routes */
export const EXPLAINER_LEASE_ROUTE = `/${RENTAL_MANAGER_PATH}/static/protected/pdf/:filename`;
export const DEFAULT_EXPLAINER_LEASE = `ExplainerLease.pdf`;
export const SAMPLER_LEASE = `Multi_State_SamplerLease.pdf`;
/* End: Misc Routes */

/* Begin: Waitlist Routes */
export const GENERIC_WAITLIST = `/${RENTAL_MANAGER_PATH}/waitlist`;
/* End: Waitlist Routes */

/* Begin: External Routes */
export const YOUR_RENTAL = `/rental/your-rental`;
/* End: External Routes */

/* Helper Functions */
export function isColandlordPath(pathname: string): boolean {
  return pathname.includes(COLANDLORD_ROOT);
}

/**
 * True on routes that render the top header nav (renter-hub / colandlord) rather than the
 * left-nav layout. Used to pick the desktop chrome height for the shared ErrorPageContainer.
 */
export function usesHeaderNav(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const { pathname } = window.location;
  return pathname.includes(RENTER_HUB_PATH) || isColandlordPath(pathname);
}
/* End: Helper Functions */
